import request from '@/utils/request'

// 查询募捐项目管理列表
export function listDonation(query) {
  return request({
    url: '/h5/donation/list',
    method: 'get',
    params: query
  })
}

// 查询募捐项目管理详细
export function getDonation(id) {
  return request({
    url: '/h5/donation/' + id,
    method: 'get'
  })
}
